import { Card } from "@/components/ui/card";

export function DevLoginLinks() {
  const devAccounts = [
    {
      name: "Quantfolio Admin",
      tenant: "quantfolio",
      email: "admin@quantfol.io",
      password: "Velkommen25",
    },
    {
      name: "Compliance (read-only)",
      tenant: "quantfolio",
      email: "compliance@quantfol.io",
      password: "Velkommen25",
    },
    {
      name: "Helge",
      tenant: "helge",
      email: "helge@quantfol.io",
      password: "Velkommen25",
    },
    {
      name: "Bjørnar",
      tenant: "bjornar",
      email: "bjornar@quantfol.io",
      password: "Velkommen25",
    },
    {
      name: "Martin",
      tenant: "martin",
      email: "martin@quantfol.io",
      password: "Velkommen25",
    },
    {
      name: "Jan Åge",
      tenant: "janaage",
      email: "jas@quantfol.io",
      password: "Velkommen25",
    },
    {
      name: "Nitheesh",
      tenant: "nitheesh",
      email: "nitheesh@quantfol.io",
      password: "Velkommen25",
    },
    {
      name: "Demo OIDC",
      tenant: "demo-oidc",
      email: "admin@demo-oidc.com",
      password: "Velkommen25",
    },
  ];

  // Keep the rest of the login query: during an OAuth (MCP / app) login it carries the
  // signed authorize request, and dropping it lands the user on the dashboard instead.
  const createLoginUrl = (tenant: string, email: string, password: string) => {
    const params = new URLSearchParams(window.location.search);
    params.set("tenant", tenant);
    params.set("email", email);
    params.set("password", password);
    return `/login?${params.toString()}`;
  };

  return (
    <Card className="p-6">
      <div className="mb-4">
        <h3 className="text-sm font-semibold flex items-center gap-2">
          Development Mode - Quick Login
        </h3>
        <p className="text-xs text-muted-foreground mt-1">
          Click to prefill login form. Only available in development.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-2">
        {devAccounts.map((account) => (
          <a
            key={account.email}
            href={createLoginUrl(account.tenant, account.email, account.password)}
            className="block p-3 rounded-lg border hover:bg-muted/50 transition-colors"
          >
            <span className="font-medium text-sm">{account.name}</span>
            <p className="text-xs text-muted-foreground mt-0.5 font-mono">{account.tenant}</p>
          </a>
        ))}
      </div>
    </Card>
  );
}
